<template>
  <div>
    <label class="control-label">{{ piece.name }}</label>
    <p class="piece-instructions" v-if="piece.options.instructions" v-html="piece.options.instructions"></p>
    <input
      type="url"
      v-model="url"
      :class="'form-control ' + piece.name"
      :name="'pieces[' + pieceIndex + '][data][oembed_url]'"
      class="messagearea step-messagearea one-line-input"
    />
    <div class="step-spacer"></div>
    <template v-if="content && !contentLoading">
      <input type="hidden" :name="'pieces[' + pieceIndex + '][content]'" :value="content" />
      <div class="content container-fluid">
        <div class="col-md-10 col-md-offset-1" v-html="content"></div>
      </div>
      <div class="step-spacer"></div>
    </template>
    <div v-if="contentLoading" class="embed-loading-indicator"></div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';
import {getIframely} from '../../../../utility/api/iframely/getIframely';

export default {
  name: 'embed-piece',
  props: {
    pieceIndex: {
      type: Number,
      required: true,
    },
    piece: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      content: '',
      contentLoading: false,
      url: '',
    };
  },
  computed: {
    required() {
      return this.piece && this.piece.options && ['1', 'true', 'yes'].includes(String(this.piece.options.required).toLowerCase());
    },
    savingDisabled() {
      return this.contentLoading || (this.required && !this.content) || (this.url && !this.content);
    },
  },
  methods: {
    changeContent(url) {
      if (!url) {
        this.content = '';
      } else {
        this.contentLoading = true;
        getIframely(url).then(data => {
          this.content = data.html;
          this.contentLoading = false;
        });
      }
    },
    disableSavingForm(disabled) {
      this.$emit('disable-saving', {
        disabled,
        pieceId: this.piece.id,
        message: `${this.piece.name} content has not been loaded.`,
      });
    },
    loadIframelyScript() {
      if (!document.getElementById('iframely-script')) {
        const iframelyScript = document.createElement('script');
        iframelyScript.id = 'iframely-script';
        iframelyScript.setAttribute('src', '//cdn.iframe.ly/embed.js');
        document.body.appendChild(iframelyScript);
      }
    },
    isValidUrl(string) {
        let url;
        try {
            url = new URL(string);
        } catch (_) {
            return false;
        }
        return url.protocol === 'http:' || url.protocol === 'https:';
    },
  },
  watch: {
    content: {
      immediate: false,
      handler(content) {
        if (content && window.iframely) {
          setTimeout(() => window.iframely.load(), 100);
        }
      },
    },
    piece: {
      immediate: true,
      handler(piece) {
        if (this.isValidUrl(piece.content)) {
          this.$nextTick(() => {
            this.url = piece.content;
          });
        } else {
            this.url = piece.data?.oembed_url || piece.options?.oembed_url || '';
            this.content = this.url ? piece.content : '';
        }
      },
    },
    savingDisabled: {
      immediate: true,
      handler(savingDisabled) {
        this.disableSavingForm(savingDisabled);
      },
    },
    url: {
      immediate: false,
      handler: debounce(function(url) {
        this.changeContent(url);
      }, 1000),
    },
  },
  mounted() {
    this.loadIframelyScript();
  },
};
</script>

<style lang="scss" scoped>
.embed-loading-indicator {
    background: center / 50px no-repeat url("/wp-content/themes/snappy-theme/assets/images/loading2.gif");
    width: 50px;
    height: 50px;
    margin: 0 auto;
}
</style>
